export const time_zone_options = {
  SUCCESS: 'FETCH_TIMEZONE_OPTIONS_SUCCESS',
  LOADING: 'FETCH_TIMEZONE_OPTIONS_LOADING'
};
